module.exports = __webpack_public_path__ + "img/dollars-connecting.062337ed.png";